module.exports = __webpack_public_path__ + "static/media/kungfuNoodleBanner.a2de33d1.png";